import React from "react";
import "./AdminDashboard.css";
import {Col, Container, Row, Tab, Tabs} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import StatisticsTab from "./tabs/statisticsTab/StatisticsTab";
import SentinelTab from "./tabs/sentinelTab/SentinelTab";
import SystemTab from "./tabs/systemTab/SystemTab";

class AdminDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    return (
       <Container className="mt-3">
         {this.state.apiError ? (
             <Row>
               <Col>{this.state.apiError}</Col>
             </Row>
         ) : (
             ""
         )}

         <Row>
           <Col className="p-0">
             <Tabs defaultActiveKey="system">
                 <Tab
                     eventKey="system"
                     tabClassName="item-link"
                     title={t("Dashboard.AdminDashboard.SystemTabTitle")}
                 >
                     <SystemTab />
                 </Tab>
                   <Tab
                       eventKey="sentinel"
                       tabClassName="item-link"
                       title={t("Dashboard.AdminDashboard.SentinelTabTitle")}
                   >
                     <SentinelTab />
                   </Tab>
               <Tab
                   eventKey="statistics"
                   tabClassName="item-link"
                   title={t("Dashboard.AdminDashboard.StatisticsTabTitle")}
               >
                 <StatisticsTab />
               </Tab>
             </Tabs>
           </Col>
         </Row>
       </Container>
   );
  }
}

export default withTranslation()(AdminDashboard);
